import { FunctionComponent } from "react";
import { IToast, ToastActionType } from "../../modules/toast/context/toast.interface";
import * as styles from "./styles.module.scss";
interface IProps {
  toasts: IToast[];
  removeToast: (id: string) => void;
}
const getIcon = (type: ToastActionType) => {
  switch (type) {
    case ToastActionType.ERROR:
      return <span data-content="report" className={`${styles.icon} mat-symbol-round-fill`} />;

    case ToastActionType.WARN:
      return <span data-content="warning" className={`${styles.icon} mat-symbol-round-fill`} />;

    case ToastActionType.INFO:
      return <span data-content="info" className={`${styles.icon} mat-symbol-round-fill`} />;

    case ToastActionType.SUCCESS:
      return <span data-content="&#xe86c;" className={`${styles.icon} mat-symbol-round-fill`} />;
    default:
      return "";
  }
};

const ToastComponent: FunctionComponent<IProps> = (props) => {
  return (
    <div className={styles.toastListWrapper}>
      {props.toasts &&
        props.toasts.length > 0 &&
        props.toasts.map((toast) => (
          <div key={toast.id} className={`${styles.toastContainer} ${styles[toast.options.type] || styles.INFO}`}>
            {getIcon(toast.options?.type)}
            <span className={styles.message}>{toast.message}</span>
          </div>
        ))}
    </div>
  );
};
export default ToastComponent;
